import React, { PureComponent, Fragment } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Link } from 'formlabs-web-components/Link';
import { Header } from 'formlabs-web-components/Type';
import './OrderedLinkList.module.css';

const OrderedLinkList = DisplayComponent(
  class OrderedLinkList extends PureComponent {
    render() {
      const { title, items, classes } = this.props;
      return (
        <Fragment>
          <Header level={6} displayAs={6}>
            {title}
          </Header>
          <div styleName="link-list" className={classes}>
            {items.map((item, i) => {
              return (
                <div key={`${item.link} ${item.title}`}>
                  <Link to={item.link}>
                    <div styleName="number-container">
                      <span styleName="number">{i + 1}</span>
                    </div>
                    <div>
                      <span>{item.title}</span>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </Fragment>
      );
    }
  }
);

OrderedLinkList.propTypes = {};

export default OrderedLinkList;
